import { Link } from "react-router-dom";
import Typography from "../components/v2/Typography";
import Button from "../components/v2/Button";
import { ArrowRight, ArrowRightCircle } from "lucide-react";
import ServicesHeader from "../atoms/ServicesHeader";
import ContactSection from "../atoms/Contact";
import BlogSection from "../atoms/BlogPreview";
import Footer from "../atoms/Footer";

const ServiceShowcase = ({ title, description1, description2, imageUrl, buttonText1, buttonLink1, buttonText2, buttonLink2 }) => {
    return (
        <section className="service-showcase left-aligned">
            <div className="inner">
                <div className="service-image">
                    <img src={imageUrl} alt={title} />
                </div>
                <div className="service-content">
                    <div className="service-text">
                        <div className="service-heading">
                            <Typography variant="h1">{title}</Typography>
                        </div>
                        <div className="service-para">
                            <Typography variant="para">{description1}</Typography>
                            <Typography variant="para">{description2}</Typography>
                        </div>
                    </div>
                    <div className="service-controls">
                        {buttonText1 && (
                            <Button variant='primary' isLink linkProps={{ to: buttonLink1 }}>
                                <Typography variant={'button'}>{buttonText1}</Typography>
                            </Button>
                        )}
                        {buttonText2 && (
                            <Button variant='secondary' isLink linkProps={{ to: buttonLink2 }}>
                                <Typography variant={'button'}>{buttonText2}</Typography>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};


const ServiceShowcaseR = ({ title, description1, description2, imageUrl, buttonText1, buttonLink1, buttonText2, buttonLink2 }) => {
    return (
        <section className="service-showcase right-aligned">
            <div className="inner">
                <div className="service-image">
                    <img src={imageUrl} alt={title} />
                </div>
                <div className="service-content">
                    <div className="service-text">
                        <div className="service-heading">
                            <Typography variant="h1">{title}</Typography>
                        </div>
                        <div className="service-para">
                            <Typography variant="para">{description1}</Typography>
                            <Typography variant="para">{description2}</Typography>
                        </div>
                    </div>
                    <div className="service-controls">
                        {buttonText1 && (
                            <Button variant='primary' isLink linkProps={{ to: buttonLink1 }}>
                                <Typography variant={'button'}>{buttonText1}</Typography>
                            </Button>
                        )}
                        {buttonText2 && (
                            <Button variant='secondary' isLink linkProps={{ to: buttonLink2 }}>
                                <Typography variant={'button'}>{buttonText2}</Typography>
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </section>
    );
};


const Services = () => {
    return (
        <>
            <ServicesHeader active="/services" />
            <ServiceShowcase
                title="Domain Acquisition"
                description1="Whether you are a new comer looking for a second form of revenue or a Fortune 500 Corporation looking to acquire that perfect domain NameConnect can help you."
                description2="We operate on multiple levels: discreet acquisitions, consultations on investments, portfolio management as well as intermediaries between parties to form alliances and lease plans."
                imageUrl="/images/services/acquisiton.jpg" // Replace
                buttonText1="Request a Acquisition"
                buttonLink1="/contact"
                buttonText2="Know more"
                buttonLink2="/services/domain-acquisition" // Replace with actual link
            />
            <ServiceShowcaseR
                title="Domain Brokering"
                description1="Whether you are a new comer looking for a second form of revenue or a Fortune 500 Corporation looking to acquire that perfect domain NameConnect can help you."
                description2="We operate on multiple levels: discreet acquisitions, consultations on investments, portfolio management as well as intermediaries between parties to form alliances and lease plans."
                imageUrl="/images/services/domain-broker.jpg" // Replace
                buttonText1="Want to buy or sell domain?"
                buttonLink1="/contact"
                buttonText2="Know more"
                buttonLink2="/services/domain-brokering" // Replace with actual link
            />
            <ServiceShowcase
                title="Domain Appraisal"
                description1="Domain Appraisal is the expert process of estimating the value of a domain name by analyzing various key factors. It considers comparable sales in the market, assessing how similar domains have been priced or sold recently. "
                description2="The appraisal also evaluates the brandability of the domain how memorable, catchy, and marketable it is for businesses or individuals. Additionally, keyword trends are examined to understand how relevant and in-demand the domain’s keywords are in search engines and popular industries."
                imageUrl="/images/services/appraisal.jpg" // Replace
                buttonText1="Request a Appraisal"
                buttonLink1="/contact"
                buttonText2="Know more"
                buttonLink2="/services/domain-appraisals" // Replace with actual link
            />
            <ServiceShowcaseR
                title="Domain Name Consultations"
                description1="Choosing the right domain name or managing a domain portfolio can be complex. Many factors influence the value and effectiveness of domain names, from branding to SEO, market trends to legal considerations. At NameConnect, we simplify this for you."
                description2="Whether you need to protect your brand, increase web traffic, or optimize your digital portfolio, our expert consultants will guide you to the fastest, most effective solutions."
                imageUrl="/images/services/consultation.jpg" // Replace
                buttonText1="Contact Us for Consultation"
                buttonLink1="/contact"
                buttonText2="Why us?"
                buttonLink2="/services/consultation" // Replace with actual link
            />
            <ServiceShowcase
                title="Strategy"
                description1="Managing a large portfolio of generic domain names can be complex and time-consuming. Weekly offers might undervalue your domains, and keeping track of renewals, market trends, and sales opportunities adds extra hassle."
                description2="At NameConnect, we help you take control. Our experts analyze your portfolio and design strategies to maximize its value — whether through smart sales, lease options, or long-term management."
                imageUrl="/images/services/portfolio.jpg" // Replace
                buttonText1="Request a Portfolio Review"
                buttonLink1="/contact"
                buttonText2="Why it Matters?"
                buttonLink2="/services/strategy" // Replace with actual link
            />
            {/* <ServiceShowcaseR
                title="Discreet Domain Acquisitions"
                description1="Sometimes, the perfect domain name is already owned by someone else. Whether it’s for a rebrand, product launch, investment, or protecting your IP, acquiring it can be sensitive and complex."
                description2="We specialize in discreet domain acquisitions — negotiating and securing high-value domain names on behalf of our clients without revealing your identity or intentions."
                imageUrl="/images/services/discreet.jpg" // Replace
                buttonText1="Request a Discreet Acquisition"
                buttonLink1="/contact"
                buttonText2="Learn more"
                buttonLink2="/services/discreet" // Replace with actual link
            /> */}
            <ServiceShowcaseR
                title="Marketing & Design"
                description1="Owning the perfect domain is just the beginning. Turning that domain into a strong, recognizable brand requires expert marketing and design."
                description2="With over five years in the industry, NameConnect partners with top web development, marketing, and design companies to help you build your online presence — no matter your budget."
                imageUrl="/images/services/marketing.jpg" // Replace
                buttonText1="Explore Marketing & Design Options"
                buttonLink1="/contact"
                buttonText2="Learn more"
                buttonLink2="/services/marketing-design" // Replace with actual link
            />
            <ContactSection />
            <BlogSection />
        </>
    );
};

export default Services;